module.exports = __webpack_public_path__ + "static/media/mental-health-awareness-training.b6b5f6d5.svg";